import { a as v } from "./tracebehavior-5_qSKjs6.js";
import { t as S } from "./properties-C_pgb9zu.js";
import { v as b } from "./AssetTypes-DUDo9FdH.js";
import { _ as A, g as E, h as F, v as L, y as O } from "./TraceScene-CTdK35pV.js";
import { i as w } from "./assetRef-BeDJZkjy.js";
var h = {
  translation: 3,
  rotation: 4,
  scale: 3
};
function J(e, t) {
  if (e === void 0) return;
  if (e === null || typeof e != "object" || Array.isArray(e)) throw new Error(`Invalid transform on node ${JSON.stringify(t)}: expected an object.`);
  const s = e.parent, n = typeof s == "string" && s ? `${s}/${t}` : t;
  for (const r of Object.keys(h)) {
    const o = e[r];
    if (o !== void 0 && (!Array.isArray(o) || o.length !== h[r] || !Array.from(o).every((i) => typeof i == "number" && Number.isFinite(i))))
      throw new Error(`Invalid transform.${r} on node ${JSON.stringify(n)}: expected ${h[r]} finite numbers.`);
  }
}
var R = "assets", d = `${R}/`, P = "trace-content/scenes/";
function I(e, t, s = {}) {
  if (!e || !e.trim()) return {
    class: "rejected",
    reason: "A files[] entry must carry a uri."
  };
  const n = e.trim();
  if (s.rejectSceneFolderUrls && D(n)) return {
    class: "rejected",
    reason: "An asset may not reference a scene folder; promotion copies the bytes across that line instead."
  };
  const r = y(n);
  if (!r) return x(n);
  if (U(r, s.storageBaseUrl))
    return t?.split(";")[0].trim().toLowerCase() === "model/gltf-binary" && /^https?:\/\/[^/?#]+(\/[^?#]*)/i.exec(n)?.[1] === r.pathname && B(r.pathname) ? { class: "legacyBlob" } : {
      class: "rejected",
      reason: "A URL into Trace blob storage must be a legacy GUID GLB reference; otherwise use a relative assets/ uri or the asset file endpoint."
    };
  const o = s.apiBaseUrl ? w(r.toString(), s.apiBaseUrl) : null;
  return o ? {
    class: "libraryRef",
    assetId: o
  } : b(t) ? { class: "foreignMedia" } : {
    class: "foreignMedia",
    reason: `A URL on a foreign host is only allowed for GLB, image or streamable media; '${t ?? "(no mimeType)"}' is not.`
  };
}
function Y(e, t = {}) {
  const s = [], n = [];
  return e.forEach((r, o) => {
    const i = I(r?.uri, r?.mimeType, t);
    if (i.reason) {
      s.push({
        index: o,
        uri: r?.uri,
        class: i.class,
        reason: i.reason
      });
      return;
    }
    n.push({
      index: o,
      uri: r.uri.trim(),
      mimeType: r.mimeType,
      class: i.class,
      ...i.assetId ? { assetId: i.assetId } : {}
    });
  }), {
    ok: s.length === 0,
    offenders: s,
    references: n
  };
}
function K(e) {
  return e.map((t) => `  • files[${t.index}] (${t.class}): ${t.reason}${t.uri ? ` — '${t.uri}'` : ""}`).join(`
`);
}
function y(e) {
  if (/^https?:\/\//i.test(e))
    try {
      const t = new URL(e);
      return t.host ? t : void 0;
    } catch {
      return;
    }
}
function m(e) {
  return !!e && y(e) !== void 0;
}
function _(e) {
  if (!j(e)) return !1;
  const t = e.slice(d.length);
  if (t.includes("?") || t.includes("#")) return !1;
  const s = t.lastIndexOf(".");
  return s > 0 && s < t.length - 1;
}
function j(e) {
  if (!e.startsWith(d)) return !1;
  const t = e.slice(d.length);
  return t.length > 0 && !t.includes("/") && !t.includes("\\") && !t.includes("..");
}
function x(e) {
  return _(e) ? { class: "folderFile" } : {
    class: "rejected",
    reason: `A relative uri must be '${d}<name>.<ext>' inside this folder.`
  };
}
function D(e) {
  return e.toLowerCase().includes(P);
}
function U(e, t) {
  const s = t ? y(t) : void 0;
  return !!s && e.hostname.toLowerCase() === s.hostname.toLowerCase();
}
function B(e) {
  return /^\/trace-cms-assets\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\.[gG][lL][bB]$/.test(e);
}
function X(e) {
  const t = [];
  for (const s of e) {
    const n = T(s);
    if (s.src && !m(s.src) && t.push({
      nodePath: n,
      field: "src",
      value: s.src
    }), s.behaviors) for (const r of s.behaviors) k(r, n, t);
  }
  return {
    ok: t.length === 0,
    offenders: t
  };
}
function q(e) {
  return e.map((t) => `  • ${t.nodePath} (${t.field}): ${t.value}`).join(`
`);
}
function T(e) {
  const t = e.transform?.parent;
  return t ? `${t.startsWith("/") ? t.slice(1) : t}/${e.name}` : e.name;
}
function k(e, t, s) {
  if (!e || typeof e != "object") return;
  const n = e, r = typeof n["@type"] == "string" ? n["@type"] : "behavior", o = /* @__PURE__ */ new Set(), i = (u, c) => {
    const l = `${t}|${c}`;
    o.has(l) || (o.add(l), s.push({
      nodePath: t,
      field: u,
      value: c
    }));
  }, a = /* @__PURE__ */ new Set(), f = (u, c) => {
    const l = `${t}|${u}|${c}`;
    a.has(l) || (a.add(l), s.push({
      nodePath: t,
      field: u,
      value: c
    }));
  };
  for (const u of F) {
    const c = n[u];
    p(c) && i(`${r}.${u}`, c);
  }
  for (const { parent: u, key: c } of E) {
    const l = n[u]?.[c];
    p(l) && i(`${r}.${u}.${c}`, l);
  }
  g(n, t, r, i), n["@type"] === "Properties" && (M(n, f), N(n, f));
}
function p(e) {
  return typeof e == "string" && e.length > 0 && !m(e) && !v(e);
}
function M(e, t) {
  const s = e.sheets;
  if (Array.isArray(s))
    for (const [n, r] of s.entries()) p(r) && t(`Properties.sheets[${n}]`, r);
}
function N(e, t) {
  const s = Array.isArray(e.properties) ? e.properties : [], n = /* @__PURE__ */ new Set();
  for (const o of s)
    typeof o?.name != "string" || typeof o.kind != "string" || (n.add(o.name), p(o.value) && t(`Properties.${o.name}`, o.value));
  if (n.size === 0) return;
  const r = e.states;
  if (r && typeof r == "object") {
    for (const [o, i] of Object.entries(r))
      if (i?.values)
        for (const [a, f] of Object.entries(i.values)) n.has(a) && p(f) && t(`Properties.states.${o}.${a}`, f);
  }
}
function g(e, t, s, n, r = 0, o = /* @__PURE__ */ new WeakSet()) {
  if (!(r > 5 || !e || typeof e != "object") && !o.has(e)) {
    o.add(e);
    for (const [i, a] of Object.entries(e))
      A(e, i) || (i === "src" && p(a) ? n(`${s}.${i}`, a) : typeof a == "object" && a !== null && g(a, t, s, n, r + 1, o));
  }
}
function Q(e, t) {
  const s = /* @__PURE__ */ new Map();
  for (const n of e) {
    const r = t(n)?.getBehavior(S);
    if (r)
      for (const o of n.behaviors ?? []) {
        if (o["@type"] !== "Properties") continue;
        const i = o.sheets;
        if (Array.isArray(i))
          for (const a of i) {
            if (s.has(a)) continue;
            const f = r.getLoadedSheet(a);
            f && s.set(a, structuredClone(f));
          }
      }
  }
  return s;
}
function $(e) {
  return (e.declarations ?? []).filter((t) => t.type === "string" && typeof t.value == "string" && (L(t.value) || m(t.value) || O(t.value)));
}
function Z(e, t) {
  const s = new Set($(e));
  let n = !1;
  const r = e.declarations?.map((o) => {
    if (!s.has(o)) return o;
    const i = t.get(o.value);
    return i === void 0 || i === o.value ? o : (n = !0, {
      ...o,
      value: i
    });
  });
  return n ? {
    ...e,
    declarations: r
  } : e;
}
function ee(e) {
  for (const [t, s] of e) {
    const n = new Set($(s));
    for (const r of s.declarations ?? [])
      if (r.type === "string" && (typeof r.kind == "string" || n.has(r)) && p(r.value))
        throw new Error(`Sheet "${t}" property "${r.name}" is not a hosted asset: ${r.value}`);
  }
}
function C(e, t) {
  if (t.size === 0) return e;
  const s = /* @__PURE__ */ new WeakSet(), n = (r, o) => typeof r == "string" ? t.get(r) ?? r : !r || typeof r != "object" || o > 5 || s.has(r) ? r : (s.add(r), Array.isArray(r) ? r.map((i) => n(i, o + 1)) : Object.fromEntries(Object.entries(r).map(([i, a]) => [i, A(r, i) ? a : n(a, o + 1)])));
  return n(e, -1);
}
function te(e, t) {
  const s = e;
  if (!s || !Array.isArray(s.files) || t.size === 0) return e;
  const n = /* @__PURE__ */ new Map(), r = s.files.map((i) => {
    const a = i?.uri, f = typeof a == "string" ? t.get(a) : void 0;
    return f === void 0 || f === a ? i : (n.set(a, f), n.set(`./${a}`, `./${f}`), {
      ...i,
      uri: f
    });
  }), o = n.size > 0 && Array.isArray(s.nodes) ? s.nodes.map((i) => {
    const a = i?.extras?.trace;
    if (!a?.behaviors) return i;
    const f = i;
    return {
      ...f,
      extras: {
        ...f.extras,
        trace: {
          ...a,
          behaviors: C(a.behaviors, n)
        }
      }
    };
  }) : s.nodes;
  return {
    ...s,
    files: r,
    ...o === void 0 ? {} : { nodes: o }
  };
}
var re = "already-in-folder";
export {
  Y as _,
  Q as a,
  q as c,
  d,
  I as f,
  _ as g,
  j as h,
  ee as i,
  X as l,
  m,
  C as n,
  $ as o,
  K as p,
  te as r,
  Z as s,
  re as t,
  R as u,
  J as v
};

//# sourceMappingURL=types-CzLXLofj.js.map